import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IBankInfoAgreementPopUp} from 'src/app/interfaces/accountant.interfaces';
import {IDropdownObject} from 'src/app/interfaces/dropdown-object.interface';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {EmployeeService} from 'src/app/services/employee.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';

@UntilDestroy()
@Component({
  selector: 'app-agreement-popup',
  templateUrl: './agreement-popup.component.html',
  styleUrls: ['./agreement-popup.component.scss'],
})
export class AgreementPopupComponent implements OnInit {
  public agreementForm!: UntypedFormGroup;
  public isCreate = false;
  public ndaDropdown: IDropdownObject[] = [];

  constructor(
    private _fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    private employee: EmployeeService,
    @Optional() @Inject(DIALOG_DATA) public data: IBankInfoAgreementPopUp
  ) {}

  ngOnInit(): void {
    if (!this.data.content.id) {
      this.isCreate = true;
    }
    this.ndaDropdown = this.data.dropdown;
    this.agreementForm = this._fb.group({
      id: new UntypedFormControl(this.data.content.id),
      agreementNo: new UntypedFormControl(this.data.content.agreementNo),
      agreementStartDate: new UntypedFormControl(
        this.data.content.agreementStartDate
      ),
      agreementEndDate: new UntypedFormControl(
        this.data.content.agreementEndDate
      ),
      nda: new UntypedFormControl(this.data.content.nda),
      comment: new UntypedFormControl(this.data.content.comment),
      bankInfoId: new UntypedFormControl(this.data.content.bankInfoId),
    });
  }

  save() {
    this.dialogRef.close(this.agreementForm.value);
  }

  close() {
    this.dialogRef.close();
  }

  deleteAgreement() {
    if (!this.data.content.id) return;
    this.employee
      .deleteAgreement(this.data.content.id)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.dialogRef.close('delete'));
  }
}
